module.exports = __webpack_public_path__ + "static/media/key-icon.dfc34cf8.svg";